export default "__VITE_ASSET__nxNhYtQT__"